import React from 'react';

import DetailPageHeader from '../components/detail-page-header';

function HomeContainer(): React.ReactElement {
  return <DetailPageHeader title="Home" />;
}

export default HomeContainer;
